export default {
  namespaced: true,
  state: {
    query: "",
    originalQuery: "",
    selectedFilter: "Alle"
  },
  mutations: {
    SET_QUERY(state, value) {
      state.query = (value || "").toLowerCase();
      state.originalQuery = value || "";
    },
    SET_SELECTED_FILTER(state, value) {
      state.selectedFilter = value;
    }
  },
  actions: {
    setQuery({ commit }, query) {
      commit("SET_QUERY", query);
    },
    selectFilter({ commit }, selectedFilter) {
      commit("SET_SELECTED_FILTER", selectedFilter);
    }
  },
  getters: {
    getOriginalQuery(state) {
      return state.originalQuery;
    },
    getEntries(state, getters, rootState) {
      const materials = (rootState.bildungsportal.searchMaterials || []).map(
        (material) => {
          return {
            name: material.Titel,
            data: {
              ...material,
              type: "Bildungsmaterial",
              filter: material.typ?.Name || "Sonstiges"
            }
          };
        }
      );

      const personsInCharge = [];

      for (const material of materials) {
        const persons = material.data.Ansprechpartner || [];

        for (const person of persons) {
          personsInCharge.push({
            ...person,
            area: [material.data.filter],
            type: "Ansprechpartner"
          });
        }
      }

      const contactPersons = rootState.bildungsportal.contactPersons || [];

      for (const person of contactPersons) {
        personsInCharge.push({
          ...person,
          area: ["Allgemein"],
          type: "Ansprechpartner"
        });
      }

      const contactPersonNames = [
        ...new Set(
          personsInCharge.map(
            (person) => `${person.firstname || ""} ${person.lastname || ""}`.trim()
          )
        )
      ].filter((name) => !!name);

      const distinctContactPersons = [];

      for (const name of contactPersonNames) {
        const personsWithName = personsInCharge.filter(
          (person) => `${person.firstname || ""} ${person.lastname || ""}`.trim() === name
        );
        const combinedAreas = personsWithName.map((person) => person.area).flat();
        const personWithName = {
          ...personsWithName[0],
          area: [...new Set(combinedAreas)]
        };

        distinctContactPersons.push({
          name,
          data: personWithName
        });
      }

      return {
        materials,
        distinctContactPersons
      };
    },
    entriesAsList(state, getters) {
      const query = state.query;
      const entries = getters.getEntries;

      return entries.materials
        .filter((item) => {
          const material = item.data;
          const titleMatches = (item.name || "").toLowerCase().includes(query);
          const subtitleMatches = (material.Subtitel || "")
            .toLowerCase()
            .includes(query);
          const typeMatches = (material.typ?.Name || "")
            .toLowerCase()
            .includes(query);
          const themaMatches = (material.Themas || []).some((thema) =>
            (thema.Name || "").toLowerCase().includes(query)
          );
          const personMatches = (material.Ansprechpartner || []).some((person) =>
            `${person.firstname || ""} ${person.lastname || ""}`
              .toLowerCase()
              .includes(query)
          );

          return (
            titleMatches ||
            subtitleMatches ||
            typeMatches ||
            themaMatches ||
            personMatches
          );
        })
        .map((item) => item.data);
    },
    filteredEntries(state, getters) {
      const filteredEntries = getters.entriesAsList;

      if (state.selectedFilter === "Alle") return filteredEntries;
      return filteredEntries.filter(
        (entry) => entry.filter === state.selectedFilter
      );
    },
    getContactPersonsForQuery(state, getters) {
      const query = state.query;
      const entries = getters.getEntries;

      const contactPersons = entries.distinctContactPersons
        .filter((item) => item.name.toLowerCase().includes(query))
        .map((item) => item.data);

      const distinctPersons = [];

      for (const contactPerson of contactPersons) {
        if (distinctPersons.find((person) => person.id === contactPerson.id)) {
          continue;
        }

        distinctPersons.push(contactPerson);
      }

      return distinctPersons;
    },
    filteredContactPersons(state, getters) {
      const entries = getters.getContactPersonsForQuery;

      if (state.selectedFilter === "Alle") return entries;
      return entries.filter((entry) =>
        (entry.area || []).includes(state.selectedFilter)
      );
    },
    getResultCountForCategory: (state, getters) => (category) => {
      const entriesAsList = getters.entriesAsList;

      if (category === "Alle") return entriesAsList.length;
      return entriesAsList.filter((item) => item.filter === category).length;
    },
    getQuery(state) {
      return state.query;
    },
    getSelectedFilter(state) {
      return state.selectedFilter;
    },
    getFilter(state, getters) {
      const filter = ["Alle"];
      const categories = getters.entriesAsList.map((entry) => entry.filter);
      filter.push(...categories);
      return [...new Set(filter)];
    }
  }
};
